<template>
  <QBtnToggle
    :class="['sai-btn-toggle', { 'sai-btn-toggle--error': error }]"
    v-on="$listeners"
    v-bind="$attrs"
    unelevated
    color="white"
    text-color="primary"
    toggle-text-color="primary"
    :clearable="clearable"
    :outline="false"
    :size="size"
    :no-caps="noCaps"
    :ripple="ripple"
  >
    <template v-for="(index, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
  </QBtnToggle>
</template>

<script>
import { QBtnToggle } from 'quasar';

export default {
  name: 'SAIBtnToggle',
  props: {
    error: {
      type: Boolean
    },
    clearable: {
      default: true
    },
    size: {
      default: 'md'
    },
    'no-caps': {
      default: true
    },
    ripple: {
      default: false
    }
  },
  components: { QBtnToggle }
};
</script>

<style lang="sass" scoped>
.sai-btn-toggle::v-deep
  border: 1px solid $primary
  border-radius: 8px

  .bg-primary
    background: $primary !important
    color: white !important

  .q-btn__wrapper
    padding: 10px 16px

  .q-btn__content
    font-size: 13px
    padding: 0 16px

@media (max-width: $breakpoint-xs-max)
  .sai-btn-toggle::v-deep
    .q-btn__wrapper
      padding: 10px 0
    .q-btn__content
      padding: 0

.sai-btn-toggle.sai-btn-toggle--error::v-deep
  border: 1px solid $negative

  .text-primary
    color: $negative !important

  .bg-primary
    background: $negative !important
    color: white !important
</style>
